import React from 'react';
import styles from './instagram-section.module.css';
import InstagramCard, { InstagramPost } from './instagram-card';
import InstagramIcon from './instagram-icon';



const INSTAGRAM_PROFILE = 'https://www.instagram.com/meghanrabbitt';

const posts: InstagramPost[] = [
  {
    id: '10 New Rules I follow',
    url: 'https://www.instagram.com/p/DQt3sFcDrr0/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mr-website-fb6db.firebasestorage.app/o/instagram%2Fig-post-10-rules.png?alt=media&token=a3e0f26b-ed8e-4ca6-8a7f-9f8a5b66ead5',
    caption: '10 New Rules I Follow After Writing The New Rules of Women\'s Health',
  },
  {
    id: 'Breast MRI',
    url: 'https://www.instagram.com/p/DUTP1psDmLe/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mr-website-fb6db.firebasestorage.app/o/instagram%2Fig-post-breast-mri.png?alt=media&token=22153ea1-de2e-4741-9ba1-2dfd15505e88',
    caption: '5 Tips I wish I read before my first breast MRI',
  },
  {
    id: 'Doc Visit Prep',
    url: 'https://www.instagram.com/p/DScyufPjtO2/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mr-website-fb6db.firebasestorage.app/o/instagram%2Fig-post-doc-visit.png?alt=media&token=a38019e5-fe4b-4ee7-a549-6262e8c77ef9',
    caption: 'Here\'s how to make the most of your next doctor\'s visit',
  },
  {
    id: '5 New Rules of Perimenopause',
    url: 'https://www.instagram.com/p/DRUdwX5DlTd/?utm_source=ig_web_copy_link&igsh=MzRlODBiNWFlZA==',
    imageUrl: 'https://firebasestorage.googleapis.com/v0/b/mr-website-fb6db.firebasestorage.app/o/instagram%2Fig-post-5-rules-peri.png?alt=media&token=ef758a09-9864-499a-8fa1-9c9e9eb8ecfe',
    caption: '5 New Rules of Perimenopause',
  }
];


export default function InstagramSection() {
  const handleFollowClick = () => {
    try {
      window.analytics?.trackEvent('instagram_follow', {
        link_url: INSTAGRAM_PROFILE,
        link_text: 'Follow on Instagram',
        platform: 'Instagram',
        page_section: 'instagram_section',
      });
    } catch { }
  };

  return (
    <section id="instagram" className={styles.section}>
      <div className={styles.container}>
        <div className={styles.header}>
          <h2 className="section-header center">Find Me on Instagram</h2>
        </div>

        <div className={styles.grid}>
          {/* ── Post Cards ── */}
          {posts.map((post, index) => (
            <div
              key={post.id}
              className={index === 3 ? styles.postResponsiveOnly : undefined}
            >
              <InstagramCard post={post} />
            </div>
          ))}

          {/* ── CTA Column ── */}
          <div className={styles.ctaColumn}>
            <InstagramIcon className={styles.ctaLogo} />
            <p className={styles.ctaTagline}>
              For more great health content
            </p>
            <p className={styles.ctaHandle}>@meghanrabbitt</p>
            <a
              href={INSTAGRAM_PROFILE}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.ctaButton}
              data-social="Instagram"
              onClick={handleFollowClick}
            >
              Follow on Instagram
              <svg
                width="18"
                height="18"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
                aria-hidden="true"
              >
                <line x1="5" y1="12" x2="19" y2="12" />
                <polyline points="12 5 19 12 12 19" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
